<div class="user-email-whatsapp-validation">
    @if (!tokenAlreadySended) {
        <form>
            <div class="form-content-wrapper">
                <input-component class="email-whatsapp-input" [placeholder]="isWhatsapp ? cellphoneMask : 'elemento.generico-input.placeholder-simplified'" [mask]="isWhatsapp ? cellphoneMask : null" [label]="'geral.user-validation.email-whatsapp.form.label.' + (isWhatsapp ? 'whatsapp' : 'email')" [control]="isWhatsapp ? whatsappControl : emailControl" />
                <span class="input-info">{{ 'geral.user-validation.email-whatsapp.form.info' | translate: { method: isWhatsapp ? 'WhatsApp.' : 'e-mail.' } }}</span>
            </div>

            <div class="buttons">
                <button customButton type="submit" [styleType]="'secondary'" [isLoading]="false" label="geral.user-validation.email-whatsapp.form.submit" (click)="handleInputSubmit()"></button>
            </div>
        </form>
    } @else {
        <div class="confirmation-token">
            <div class="confirmation-token-header">
                <div class="icon">
                    @if (isWhatsapp) {
                        <i class="fa icons fa-whatsapp"></i>
                    } @else {
                        <i-feather name="mail"></i-feather>
                    }
                </div>
                <h1>{{ 'geral.user-validation.email-whatsapp.token.title' | translate: { method: isWhatsapp ? 'WhatsApp' : 'email' } }}</h1>
                <div class="text-wrapper">
                    <p>{{ 'geral.user-validation.email-whatsapp.token.subtitle.first-line' | translate }} <b>{{ isWhatsapp ? (whatsappControl.value | mask: cellphoneMask) : emailControl.value }}</b></p>
                    <p>{{ 'geral.user-validation.email-whatsapp.token.subtitle.seccond-line' | translate: { method: isWhatsapp ? 'WhatsApp' : 'email' } }}</p>
                </div>
            </div>
            <form class="confirmation-token-form">
                <div class="form-content-wrapper">
                    <div class="input-wrapper">
                        @for (control of tokenControlList; track $index; let index = $index) {
                            <input-digit-component class="digit-input" inputId="token{{index}}" label="" (paste)="onPasteToken($event, index)" (onKeyUp)="onKeyUpToken($event, index)" [control]="control"/>
                        }
                    </div>
                    <span class="resend-token" (click)="handleInputSubmit()">
                        {{ 'geral.user-validation.email-whatsapp.token.resend' | translate }}
                    </span>
                </div>
                <div class="buttons">
                    <button id="submitTokenButton" customButton type="submit" [styleType]="'secondary'" [isLoading]="false" [label]="'geral.user-validation.email-whatsapp.token.submit' | translate: { method: isWhatsapp ? 'WhatsApp' : 'email' }" (click)="handleTokenSubmit()"></button>
                    <div class="go-back" (click)="goBackToInput()">
                        <i-feather name="arrow-left"></i-feather>
                        {{ 'geral.user-validation.email-whatsapp.token.go-back' | translate }}
                    </div>
                </div>
            </form>
        </div>
    }
</div>
